// extracted by mini-css-extract-plugin
module.exports = {"feedback__tooltip":"styles_feedback__tooltip__3a2W5","inner__text":"styles_inner__text__2Hw3L"};